export enum EDITION {
    STANDART = 'Standard Edition',
    GOLD = 'Gold Edition',
    DELUXE = 'Deluxe Edition',
    ADVANCED = 'Advanced Edition',
    ULTIMATE = 'Ultimate Edition',
    COLLECTOR = 'Collector Edition',
    DLC = 'DLC'
}
